import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "url-polyfill";
import "url-search-params-polyfill";
import cssVars from "css-vars-ponyfill";

if (typeof window !== "undefined" && typeof document !== "undefined") {
  cssVars({
    onlyLegacy: true,
    silent: true,
    watch: true,
  });
}
